import { useState, useEffect, useCallback } from "react";
import handleApiError from "../helpers/handleApiError";
import useForm from "../hooks/useForm";
import InvoiceHistorySearchForm from "./InvoiceHistorySearchForm";
import {
  getExportInvoices,
  getInvoiceHistory,
} from "../services/invoiceService";
import { useHistory } from "react-router-dom";
import { Container } from "react-bootstrap";
import { format as dateFormat, add as dateAdd } from "date-fns";
import InvoiceHistoryTable from "./InvoiceHistoryTable";
import { defaultTitle } from "../config";
import { Helmet } from "react-helmet";
import fileDownload from "js-file-download";
import jwtDecode from "jwt-decode";
import { apiUrl, tokenKeyName } from "../config";
import http from "../services/httpService";
import { ExportIcon } from "./Utility/Icons/ExportIcon";
// Data to use before the API endpoint is ready
// const mockInvoices = [
//   {
//     invoiceId: 4456921,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "04/02/2021",
//     cutoffDate: "04/30/2021",
//     amount: "$32,499.94",
//     paid: "$0.00",
//     balance: "$32,499.94",
//   },
//   {
//     invoiceId: 4456903,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "04/02/2021",
//     cutoffDate: "03/31/2021",
//     amount: "$485.00",
//     paid: "$0.00",
//     balance: "$485.00",
//   },
//   {
//     invoiceId: 4453161,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "03/05/2021",
//     cutoffDate: "02/28/2021",
//     amount: "$5,088.39",
//     paid: "$5,088.39",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4452603,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "03/02/2021",
//     cutoffDate: "02/28/2021",
//     amount: "$322.50",
//     paid: "$322.50",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4452584,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "03/02/2021",
//     cutoffDate: "03/31/2021",
//     amount: "$32,870.01",
//     paid: "$32,870.01",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4451740,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "02/24/2021",
//     cutoffDate: "02/07/2021",
//     amount: "$342.50",
//     paid: "$342.50",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4459474,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "02/03/2021",
//     cutoffDate: "02/28/2021",
//     amount: "$32,500.01",
//     paid: "$32,500.01",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4459395,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "02/02/2021",
//     cutoffDate: "01/31/2021",
//     amount: "$685.00",
//     paid: "$685.00",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4458225,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "01/29/2021",
//     cutoffDate: "01/324/2021",
//     amount: "$1,135.00",
//     paid: "$1,135.00",
//     balance: "$0.00",
//   },
//   {
//     invoiceId: 4458224,
//     clientId: 18447,
//     name: "CD-Bob Howard PDC",
//     invoiceDate: "01/29/2021",
//     cutoffDate: "01/324/2021",
//     amount: "$95.00",
//     paid: "$95.00",
//     balance: "$0.00",
//   },
// ];

const InvoiceSummaryPanel = ({ handleExportClick, grandTotals }) => {
  return (
    <center>
      <div className="paper-main-invoices invoices ">
        <div>
          <div className="row p-2">
            <div className="align-buttons-invoices">
              <ExportIcon
                role="button"
                className="no-copy"
                size={25}
                alt="Export Invoices"
                title="Export Invoices"
                onClick={handleExportClick}
              />
              {/* <TbPackgeExport
              data-toggle="tooltip"
              data-placement="top"
              title="Export Invoices"
              onClick={handleExportClick}
              onMouseEnter={onHover}
              onMouseLeave={onHoverLeave}
              size={25}
            /> */}{" "}
              &nbsp;
            </div>
            {/* <div class="col-md-4"></div>

          <div class="col-md-4 offset-md-4 offset-md-4"></div> */}
          </div>
          <div className="ordered-text">
            <div class="row">
              <div class="col-sm">
                <div></div>
              </div>
              <div class="col-sm">
                <label> Grand Totals</label>
              </div>
              <div class="col-sm">
                <div></div>
              </div>
            </div>
            <br />
            <div className="ordered-text">
              <div class="row">
                <div class="col-sm">
                  <div>
                    <label> Total:</label>
                    {grandTotals
                      ? " " +
                        grandTotals.total.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })
                      : "Loading..."}{" "}
                  </div>{" "}
                </div>
                <div class="col-sm">
                  <label> Paid:</label>
                  {grandTotals
                    ? " " +
                      grandTotals.paid.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })
                    : "Loading..."}{" "}
                </div>
                <div class="col-sm">
                  <div>
                    <label> Balance:</label>
                    {grandTotals
                      ? " " +
                        grandTotals.balance.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })
                      : "Loading..."}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <br />
          </div>
          <div
            style={{
              textAlign: "left",
              paddingLeft: "22px",
              width: "300px",
            }}
          ></div>
        </div>
        <div>
          <center></center>
        </div>
      </div>
    </center>
  );
};

const Invoices = () => {
  const [searchFormValues, setSearchFormValues] = useForm({
    fromDate: dateFormat(dateAdd(new Date(), { days: -15 }), "yyyy-MM-dd"),
    toDate: dateFormat(dateAdd(new Date(), { days: 5 }), "yyyy-MM-dd"),
  });

  const [invoices, setInvoices] = useState([]);
  const [grandTotals, setGrandTotals] = useState();
  const [hover, setHover] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const history = useHistory();

  function prependDollarSign(foundInvoices) {}

  const prependDollarSin = () => {};
  const onHover = () => {
    setHover(true);
  };
  const onHoverLeave = () => {
    setHover(false);
  };
  // API calls and handleSubmit function
  useEffect(() => {
    (async () => {
      // const defaultFromDate = dateFormat(dateAdd(new Date(), {days: -15}), 'yyyy-MM-dd')
      // const defaultToDate = dateFormat(dateAdd(new Date(), {days: 5}), 'yyyy-MM-dd')

      setLoading(true);
      setError(false);

      try {
        const { data: foundInvoices } = await getInvoiceHistory();
        // const { data: foundInvoices } = await getInvoiceHistory(defaultFromDate, defaultToDate);

        // console.log(foundInvoices);
        //call function that adds $ to total, paid, balance fields

        //Working with decimals introduces floating point precision problems i.e. .32 + .35 = .6700000001 or .669999999998
        //Rounding each sum in the process of totalling to prevent the discrepencies from adding up and getting bigger but may want to consider
        //using a "big decimal" library or some other method to avoid these floating point precision issues.
        const grandTotalsSum = foundInvoices.reduce(
          (rollingSumsObject, invoice) => {
            // console.log(rollingSumsObject);
            // console.log(rollingSumsObject.total + invoice.total);
            const rollingTotalObject = {
              total: parseFloat(
                (rollingSumsObject.total + invoice.total).toFixed(2)
              ),
              paid: parseFloat(
                (rollingSumsObject.paid + invoice.paid).toFixed(2)
              ),
              balance: parseFloat(
                (rollingSumsObject.balance + invoice.balance).toFixed(2)
              ),
            };
            // console.log(rollingTotalObject);
            // console.log(invoice);
            return rollingTotalObject;
          },
          { total: 0, paid: 0, balance: 0 }
        );
        // console.log(grandTotalsSum);
        setGrandTotals(grandTotalsSum);

        setInvoices(foundInvoices);
        setLoading(false);
      } catch (ex) {
        setLoading(false);
        setError(true);
        handleApiError(ex, history);
      }
    })();
  }, [history, setLoading]);

  const onPrintInvoiceClick = useCallback(
    (invoiceNumber) => {
      (async () => {
        setError(false);
        setLoading(true);
        try {
          //at this point it should prompt the user to download
          const { data } = await http.get(
            `${apiUrl}/InvoiceMast/InvoiceReportView?invoiceNumber=${invoiceNumber}`,
            { responseType: "blob" }
          );
          fileDownload(
            data,
            `Diligent Invoice Report - Invoice ${invoiceNumber}.pdf`
          );
          setLoading(false);
        } catch (ex) {
          setLoading(false);
          setError(true);
          handleApiError(ex, history);
        }
      })();
    },
    [history, setLoading]
  );

  const handleSearchSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError(false);

    try {
      const { data: foundInvoices } = await getInvoiceHistory(
        searchFormValues.fromDate,
        searchFormValues.toDate
      );

      setInvoices(foundInvoices);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      setError(true);
      handleApiError(ex, history);
    }
  };

  const handleExportClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    try {
      // console.log(invoices);
      //   toast.success(
      //     "Most likely going to keep using backend to generate file like on the order history page. To Discuss"
      //   );
      //need to get excel file itself from backend, filedownload, just
      // fileDownload(invoices, "Invoices - " +new Date().toDateString() +".xlsx");
      const decodedClientUser = jwtDecode(localStorage.getItem(tokenKeyName));
      //****TEST THIS ONCE BACKEND IS UPDATED */
      const { data } = await getExportInvoices();
      fileDownload(
        data,
        "Diligent Invoice History - " +
          decodedClientUser.ClientId +
          " - " +
          new Date().toLocaleDateString() +
          ".xlsx"
      );
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      setError(true);
      // console.log(ex);
      handleApiError(ex, history);
      //   toast.error("Issue Exporting File");
      //   console.log(ex);
    }
  };

  return (
    <>
      <Helmet>
        <title> Invoices - {defaultTitle}</title>
      </Helmet>
      {/* <div className="my-2">
                    <InvoiceHistorySearchForm 
                        formValues={searchFormValues}
                        setFormValues={setSearchFormValues}
                        onSubmit={handleSearchSubmit}
                    />
                </div> */}
      <div className="tw-relative tw-mb-8">
        <h1 className="tw-text-center">Invoices</h1>
        <div className="tw-absolute tw-right-0 tw-top-0">
          <ExportIcon
            role="button"
            className="no-copy"
            size={25}
            alt="Export Invoices"
            title="Export Invoices"
            onClick={handleExportClick}
          />
        </div>
      </div>

      {/* Didn't want the panel for now */}
      {/* <InvoiceSummaryPanel
          handleExportClick={handleExportClick}
          grandTotals={grandTotals}
        /> */}
      {/* <br /> */}

      <InvoiceHistoryTable
        // mockInvoices={mockInvoices}
        invoices={invoices}
        onPrintInvoiceClick={onPrintInvoiceClick}
        isLoading={loading}
        isError={error}
      />
    </>
  );
};

export default Invoices;
